import { useState } from "react";
import RevenueBySales from "./components/RevenueBySales";
import RevenueSummary from "./components/RevenueSummary";
import RevenueByOprt from "./components/RevenueByOprt";
import { Button, Checkbox, DatePicker, Form } from "antd";
import moment from "moment";
import { RiFilterOffLine } from "react-icons/ri";
import TechnicianEfficiency from "./components/TechnicianEfficiency";
import RevenueBreakdown from "./components/RevenueBreakdown";
import DateLine from "../../components/shared/DateLine";
import RevenueDept from "./components/RevenueDept";
import { useNavigate } from "react-router";

const { RangePicker } = DatePicker;

export default function Workshop() {
  const [startDate, setStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYYMMDD"));
  const [showRange, setShowRange] = useState(false);

  const [form] = Form.useForm();

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };

  const clearDate = () => {
    form.resetFields();
    setStateDate(moment(new Date()).format("YYYYMMDD"));
    setEndDate(moment(new Date()).format("YYYYMMDD"));
  };

  return (
    <div className="flex flex-col bg-white">
      <div className="grid grid-cols-12  border-b  border-gray-300 py-2 mx-4">
        <div className="col-span-12 sm:col-span-8">
          <Form layout="inline" form={form}>
            {showRange ? (
              <div className="flex justify-center items-center">
                <Form.Item name="ranger">
                  <RangePicker
                    allowClear={true}
                    onChange={onRangeChange}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Form.Item name="picker">
                  <DatePicker
                    onChange={onDateChange}
                    format={"DD-MM-YYYY"}
                    placeholder="Specific date"
                  />
                </Form.Item>
                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            )}
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
        <div className="col-span-12 sm:col-span-4">
          <div className="flex justify-center sm:justify-end items-center ">
            <DateLine startDate={startDate} endDate={endDate} />
          </div>
        </div>
      </div>
      {/* <div className="flex justify-between items-center border-b  border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            {showRange ? (
              <div className="flex justify-center items-center">
                <Form.Item name="ranger">
                  <RangePicker
                    allowClear={true}
                    onChange={onRangeChange}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Form.Item name="picker">
                  <DatePicker
                    onChange={onDateChange}
                    format={"DD-MM-YYYY"}
                    placeholder="Specific date"
                  />
                </Form.Item>
                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            )}
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
        <div className="">
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      </div> */}
      <div className="grid grid-cols-12 gap-x-3 my-2 mx-4">
        <div className="col-span-12 sm:col-span-8 md:col-span-8 mb-2 sm:mb-0">
          <div className="h-full bg-white mb-2 border border-gray-300 rounded-lg">
            <div className="border-b h-16">
              <div className="border-b h-16 flex justify-center items-center">
                <div className="font-bold">Workshop Revenue By Sales</div>
              </div>
            </div>
            <div className=" mt-2 bg-white mx-2" style={{ height: 400 }}>
              <RevenueBySales startDate={startDate} endDate={endDate} />
            </div>
          </div>
        </div>
        <RevenueSummary startDate={startDate} endDate={endDate} />
      </div>

      <div className="grid grid-cols-12 gap-x-3 mt-3 mx-4">
        <div className="col-span-12 sm:col-span-8 md:col-span-8 mb-2 sm:mb-0">
          <div className="h-full">
            <div className=" bg-white h-auto border border-gray-300 rounded-lg">
              <div className="border-b h-16">
                <div className="border-b h-16 flex justify-center items-center">
                  <div className="font-bold">
                    Workshop Revenue By Department
                  </div>
                </div>
              </div>
              <div
                className="flex justify-center items-center"
                style={{ height: 353 }}
              >
                <RevenueDept startDate={startDate} endDate={endDate} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-span-12 sm:col-span-4 md:col-span-4 mb-2 sm:mb-0">
          <div className="h-full">
            <div className=" bg-white h-auto border border-gray-300 rounded-lg">
              <div className="border-b h-20">
                <div className="border-b h-20 flex justify-center items-center">
                  <div className="font-bold">Workshop Revenue By Category</div>
                </div>
              </div>
              <div className="h-auto">
                <RevenueBreakdown startDate={startDate} endDate={endDate} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-3 mx-4 mt-3">
        <div className="col-span-12 sm:col-span-6 md:col-span-6 mb-2 sm:mb-2">
          <div className="h-full bg-white border border-gray-300 rounded-lg">
            <div className="border-b h-16">
              <div className="border-b h-16 flex justify-center items-center">
                <div className="font-bold">Workshop Revenue By Consultant</div>
              </div>
            </div>
            <div className="bg-white">
              <RevenueByOprt startDate={startDate} endDate={endDate} />
            </div>
          </div>
        </div>

        <div className="col-span-12 sm:col-span-6 md:col-span-6 mb-2 sm:mb-0">
          <div className="h-full bg-white  border border-gray-300 rounded-lg">
            <div className="border-b h-16">
              <div className="border-b h-16 flex justify-center items-center">
                <div className="font-bold">Technician Efficiency</div>
              </div>
            </div>
            <div className="bg-white">
              <TechnicianEfficiency startDate={startDate} endDate={endDate} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
